import { makeObservable, observable } from "mobx"
import { getUrlVar, removeUrlVar } from "react-sdk/utils"

class VertxHelper {

  vertxConfig = null
  vertxClient = null

  constructor(config) {
    this.vertxConfig = config
    this.vertxClient = this.#createVertx()
    this.vertxClient._SessionToken = null
    makeObservable(this.vertxClient, {
      _SessionToken: observable,
    })
  }


  #createVertx() {
    const {universe, app, anonOnly = false } = this.vertxConfig

    console.log("=== Create vertx ===")
    let vtxClient = window.gms.VertxClient.Create()

    // let vtxClient = new window.gms.VertxClient()
    // vtxClient.UserData = new window.gms.VertxCmd.$StorageUserData(client.Storage);
    vtxClient.SetUniverse(universe)
    vtxClient.SetApplication(app)
    vtxClient.SetAnonymousOnly(anonOnly)
    vtxClient.SetExternalLog(msg => {
      // console.log("vertxClient => ", msg)
    })

    vtxClient.SIG_SocketConnection.Add((status, msg) => {
      console.log("SIG_SocketConnection", status, msg)
    })
    vtxClient.SIG_SessionStatus.Add((success, msg) => {
      console.log("SIG_SessionStatus", msg)
    })

    return vtxClient

  }

  /**
   * Fais la connexion vers le vertx :
   * - check si y'a des tokens dans l'url et se connecte avec
   * - sinon, tente de se connecter par défaut (avec le token stocké localement)
   * @returns {Promise} une Promise quand la connexion est terminée avec true si on est authentifié, false sinon (jamais reject)
   */
  connect() {
    // ici si y'a les infos de token de co dans l'url, on procède à notre connexion
    let user_mail = getUrlVar("user")
    let token = getUrlVar("token")

    return new Promise( (resolve) => {
      let {universe, url, port} = this.vertxConfig
      if (token) {
        this.vertxClient.SetUserToken(universe, user_mail, null, token)
        removeUrlVar("user")
        removeUrlVar("token")
        removeUrlVar("universe")
      }

      this.vertxClient.OpenConnection(url, port, connected => {
        resolve(connected)
      })
    })

  }

  /**
   * Fais un login avec code
   * @returns {Promise} une Promise qui se resolve si on est bien login ou qui reject (avec le message en param) si y'a un soucis
   */
  loginWithCode(email, code) {
   return new Promise((resolve, reject) => {
      let {universe, app} = this.vertxConfig
      this.vertxClient.UserConnectPasswordlessWithCode(universe, app, email, code, (success, data, msg) => {
        if (success)
          resolve()
        else
          reject(msg)
      })
    })
  }

  logout() {
    return new Promise( (resolve, reject) => {
      this.vertxClient.UserDisconnect((success, msg, data) => {
        resolve()
      })
    })
  }

}

export default VertxHelper